import React from 'react'
import styles from './styles.module.scss'

type Tag = {
  name: string,
  color: string
}

export default function TagItem({ tag }: { tag: Tag } ) {
  return (<div className={styles.tag} style={{ backgroundColor: tag.color }}>{ tag.name }</div>)
}

export type { Tag }
